<script setup lang="ts">
  import { useQuery } from '@tanstack/vue-query'

  import type { Conversation } from '@/types/Conversation'
  import type { Sentence as SentenceType } from '@/types/Sentence'
  import useRelation from '@/composables/useRelation'
  import Sentence from '@/components/global/Sentence.vue'

  const props = defineProps<{
    element: Conversation
  }>()

  const { getRelatedContentFields } = useRelation()

  const { sentenceIds } = props.element

  const { data: sentenceData } = useQuery<SentenceType[]>({
    queryKey: ['sentences', props.element.sentenceIds],
    queryFn: () => getRelatedContentFields<SentenceType>(sentenceIds),
    staleTime: Infinity
  })
</script>

<template>
  <div class="conversation">
    <Sentence
      v-for="(sentence, index) in sentenceData"
      :key="index"
      :index="index"
      :element="{ ...sentence, color: index % 2 === 0 ? [1] : [0] }"
    />
  </div>
</template>

<style scoped lang="scss">
  .conversation {
    max-width: $vgs-max-width-content;
    margin: 0 auto;
    padding: 64px 0;
  }
</style>
